module.exports = __webpack_public_path__ + "img/s4Model3.a6656617.webp";